export const noMenuFilterSelectedLabel = 'Veuillez sélectionner un filtre';
export const menuItemloadingError = 'Erreur lors du chargement';
